import LoaderPage from 'components/ui/feedback/LoaderPage'
import React, { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'

const CommissionBonusesPage = lazy(() => import('pages/commissionBonuses/page'))

const CommissionBonusesRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<CommissionBonusesPage />} />} />
    </Routes>
  )
}

export default CommissionBonusesRoutes
